import { fragments as artOrderStatusFragments } from "../../application/apps/ArtApp/components/ArtOrderStatus/graph";
import { gql } from "@apollo/client";

const markOrderAsOnArtworkHoldMutation = gql`
  mutation($orderId: ID!) {
    markOrderAsOnArtworkHold(orderId: $orderId) {
      errors {
        orderId
      }
      updatedOrder {
        ...ArtOrderStatus_order
      }
      succeeded
    }
  }
  ${artOrderStatusFragments.order}
`;

export default markOrderAsOnArtworkHoldMutation;
